// extracted by mini-css-extract-plugin
export default {"header":"SignUpModal_header__n3VQc","title":"SignUpModal_title__Psmtg utils_title__PM7dd","welcome":"SignUpModal_welcome__r5Zze","footnote":"SignUpModal_footnote__ZTv0o"};